// Routine steps: felt plate, edge colour and tile geometry per kind (DESIGN.md › Step Tile; sizes from the comp).
export type StepKind = 'bath' | 'pajamas' | 'massage' | 'feed' | 'book' | 'song' | 'cuddle' | 'bed';
export type Step = { id: string; kind: StepKind; minutes: number; name?: string };

type Look = {
  name: string;
  plate: string;
  alt: string;
  edge: string;
  /** tile width in pt, roughly proportional to the step's duration */
  width: number;
  /** plate box inside the tile */
  img: { left: number; top: number; width: number; height: number };
};

export const STEP_LOOK: Record<StepKind, Look> = {
  bath: { name: 'Bath', plate: '/art/plates/tub.webp', alt: 'a felt bathtub full of bubbles', edge: 'var(--bp-step-apricot)', width: 80, img: { left: 6, top: 18, width: 68, height: 52 } },
  pajamas: { name: 'Pajamas', plate: '/art/plates/felt-pajamas.webp', alt: 'felt pajamas', edge: 'var(--bp-step-apricot)', width: 68.8, img: { left: 6.3, top: 16.8, width: 53, height: 57.3 } },
  massage: { name: 'Massage', plate: '/art/felt/comfort-lamb.webp', alt: 'a sleeping felt lamb', edge: 'var(--bp-step-mauve)', width: 70, img: { left: 8, top: 18, width: 54, height: 52 } },
  feed: { name: 'Feed', plate: '/art/plates/felt-feed.webp', alt: 'a felt bottle and cup', edge: 'var(--bp-step-sage)', width: 85, img: { left: 8.3, top: 19.8, width: 70, height: 50 } },
  book: { name: 'Book', plate: '/art/plates/felt-book.webp', alt: 'a felt picture book', edge: 'var(--bp-step-plum)', width: 74, img: { left: 6, top: 17.4, width: 62, height: 49.3 } },
  song: { name: 'Song', plate: '/art/plates/felt-song.webp', alt: 'felt music notes', edge: 'var(--bp-step-mauve)', width: 54.4, img: { left: 6.4, top: 20.8, width: 42, height: 43 } },
  cuddle: { name: 'Cuddle', plate: '/art/felt/comfort-lamb.webp', alt: 'a sleeping felt lamb', edge: 'var(--bp-step-sage)', width: 64, img: { left: 6, top: 18, width: 52, height: 50 } },
  bed: { name: 'Bed', plate: '/art/plates/felt-bed.webp', alt: 'a felt crib', edge: 'var(--bp-step-sage-deep)', width: 76, img: { left: 0, top: 11.2, width: 69.3, height: 67.9 } },
};

export const stepName = (s: Step) => s.name ?? STEP_LOOK[s.kind]?.name ?? s.kind;
